module.exports = __webpack_public_path__ + "img/5.926a9b99.gif";